import { Button, Form, FormProps, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import {
  ArrayOption,
  pathLink,
  selectSearchOption,
} from "../../../helpers/siteConfig";
import AdminLayout from "../../../layouts/AdminLayout";
import { UserData } from "../../../types/redux";

import { PlusOutlined } from "@ant-design/icons";
import { debounce } from "lodash";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import LeftArrowIcon from "../../../assets/icons/LeftArrowIcon";
import IconButton from "../../../components/common/IconButton";
import Loader from "../../../components/common/Loader";
import Subheader from "../../../components/ui/Subheader";
import AXIOS from "../../../helpers/api";
import { BASE_API } from "../../../helpers/apiUrl";
import {
  getAllAreaAsync,
  getAllRegionAsync,
  getAllTerritoryAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import {
  createSupplierAsync,
  getAllSupplierAsync,
  getSingleSupplierAsync,
  updateSupplierAsync,
} from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { removeQuotes } from "../../../utils/string";

export default function ManageVendor() {
  const [selectArea, setSelectArea] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const path = pathLink(location.pathname, 1);
  const navLink = `/${path}/vendor`;
  const [form] = Form.useForm();
  const [selectRegion, setSelectRegion] = useState("");
  const { regions, areas, territorys } = useAppSelector((state) => state.npGeo);
  const {
    allSupplier,
    singleSupplier,
    viewLoading,
    postLoading,
    updateLoading,
  } = useAppSelector((state) => state.supplier);
  const { login } = useAppSelector((state) => state.login);

  const onFinish: FormProps<UserData>["onFinish"] = (values: any) => {
    const newData = {
      firstName: values?.firstName,
      lastName: values?.lastName,
      email: values?.email,
      vendorId: values?.vendorId,
      contactNumber: values?.contactNumber,
      region: values?.region,
      area: values?.area,
      territory: values?.territory,
      walletNumber: values?.walletNumber,
      bankInfo: {
        bankName: values?.bankName,
        accountNumber: values?.accountNumber,
        accountName: values?.accountName,
        routingNumber: values?.routingNumber,
        branch: values?.branch,
        walletNumber: values?.walletNumber,
      },
    };

    if (id) {
      dispatch(
        updateSupplierAsync({
          data: newData,
          others: {
            reRender,
            id,
          },
        })
      );
    } else {
      dispatch(
        createSupplierAsync({
          data: newData,
          others: {
            reRender,
          },
        })
      );
    }
  };

  // redirect and re-render function
  const reRender = (val: boolean) => {
    if (val) navigate(navLink);
  };

  const checkEmployeeExist = debounce(
    (employeeId: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkEmployeeID, { employeeId, isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(
              err?.response?.data?.message || "Employee ID already exists"
            )
          )
        );
    },
    500
  );

  const checkEmailExist = debounce(
    (email: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkEmail, { email, isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(err?.response?.data?.message || "Email already exists")
          )
        );
    },
    500
  );

  const checkPhoneExist = debounce(
    (phoneNumber: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkPhone, { phoneNumber, isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(
              err?.response?.data?.message || "Phone number already exist"
            )
          )
        );
    },
    500
  );

  const checkNIDExist = debounce(
    (nid: string, callback: (result: string) => void) => {
      AXIOS.post(BASE_API.checkNID, { nid: String(nid), isPG: true })
        .then(() => callback(""))
        .catch((err) =>
          callback(
            removeQuotes(err?.response?.data?.message || "NID already exists")
          )
        );
    },
    500
  );

  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getAllAreaAsync({
        params: {
          region: selectRegion,
        },
      })
    );
  }, [dispatch, selectRegion]);

  useEffect(() => {
    dispatch(
      getAllTerritoryAsync({
        params: {
          area: selectArea,
        },
      })
    );
  }, [dispatch, selectArea]);

  useEffect(() => {
    dispatch(getAllSupplierAsync({}));
  }, [dispatch]);

  // console.log(
  //   allSupplier?.find((el) => el?._id === login?.suppler),
  //   login?.suppler
  // );

  useEffect(() => {
    if (
      path === "vendor" &&
      allSupplier?.find((el) => el?._id === login?.suppler)
    ) {
      form.setFieldsValue({
        suppler: login?.suppler || undefined,
      });
    }
  }, [allSupplier, form, login?.suppler, path]);

  useEffect(() => {
    if (id) {
      dispatch(
        getSingleSupplierAsync({
          params: { id },
        })
      );
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (id && singleSupplier) {
      form.setFieldsValue({
        firstName: singleSupplier?.firstName,
        lastName: singleSupplier.lastName,
        email: singleSupplier.email,
        vendorId: singleSupplier.vendorId,
        contactNumber: singleSupplier.contactNumber || [],
        region: singleSupplier.region?._id,
        area: singleSupplier.area?._id,
        territory: singleSupplier.territory?._id,
        bankName: singleSupplier.bankInfo?.bankName,
        accountNumber: singleSupplier.bankInfo?.accountNumber,
        accountName: singleSupplier.bankInfo?.accountName,
        routingNumber: singleSupplier.bankInfo?.routingNumber,
        branch: singleSupplier.bankInfo?.branch,
        walletNumber: singleSupplier.bankInfo?.walletNumber,
      });

      setSelectRegion(singleSupplier.region?._id);
      setSelectArea(singleSupplier.area?._id);
    }
  }, [form, id, singleSupplier]);

  return (
    <>
      <AdminLayout
        title={id ? "Edit Vendor" : "Add New Vendor"}
        headerTitle="Vendor"
      >
        {id && viewLoading ? (
          <Loader />
        ) : (
          <section className={`shadow-sm bg-white rounded-lg mt-7 pb-7`}>
            <Subheader title={id ? "Edit Vendor" : "Add New Vendor"}>
              <Space size="middle">
                <Link to={navLink}>
                  <IconButton
                    className="!border-others-header !text-sm !font-normal !rounded-lg !border !text-header !bg-transparent"
                    type="default"
                    icon={<LeftArrowIcon />}
                  >
                    <span>Back</span>
                  </IconButton>
                </Link>
              </Space>
            </Subheader>

            <div className="w-full mx-auto px-6 pt-14 min-h-[400px]">
              <Form
                className="custom-form hide_star_mark"
                layout="vertical"
                onFinish={onFinish}
                size="large"
                form={form}
              >
                <div className="flex items-center gap-4 mb-5">
                  <div className="text-slate-600 text-lg font-semibold">
                    General Information
                  </div>
                  <div className="flex-1 h-px bg-zinc-200"></div>
                </div>

                <div className="grid grid-cols-2 items-start gap-x-6 gap-y-0">
                  <Form.Item
                    name="firstName"
                    label="First Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter operator first name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter first name"
                      allowClear
                    />
                  </Form.Item>
                  <Form.Item
                    name="lastName"
                    label="Last Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter operator last name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter last name"
                      allowClear
                    />
                  </Form.Item>

                  {/* <Form.Item
                  name="contactNumber"
                  label="Contact Number"
                  rules={[
                    {
                      required: true,
                      message: "Please enter phone number",
                    },
                    {
                      validator: async (_: any, value: string) => {
                        if (!value) {
                          return Promise.resolve();
                        }

                        const phoneRegex = /^(\+88)?(01[3-9])[0-9]{8}$/;
                        if (!phoneRegex.test(value)) {
                          return Promise.reject(
                            new Error(
                              "Please enter a valid Bangladeshi phone number"
                            )
                          );
                        }

                        return new Promise<void>((resolve, reject) => {
                          checkPhoneExist(value, (result: string) => {
                            if (result) {
                              reject(new Error(result));
                            } else {
                              resolve();
                            }
                          });
                        });
                      },
                    },
                  ]}
                >
                  <Input
                    prefix={"BD "}
                    size="large"
                    placeholder="Mobile No:"
                    allowClear
                  />
                </Form.Item> */}

                  <Form.Item
                    name="vendorId"
                    label="Vendor ID"
                    rules={[
                      {
                        required: true,
                        message: "Please enter vendor ID",
                      },
                      {
                        validator: async (_: any, value: string) => {
                          if (!value) return Promise.resolve();

                          const trimmedValue = value.trim();

                          // Rule 1: No leading hyphen or underscore
                          if (/^[-_]/.test(trimmedValue)) {
                            return Promise.reject(
                              new Error("Are not allowed start with '-' or '_'")
                            );
                          }

                          // Rule 2: No decimal points
                          if (trimmedValue.includes(".")) {
                            return Promise.reject(
                              new Error("Decimal points are not allowed")
                            );
                          }

                          // Rule 3: No spaces
                          if (/\s/.test(trimmedValue)) {
                            return Promise.reject(
                              new Error("Spaces are not allowed")
                            );
                          }

                          // Rule 4: Only allow alphanumeric characters, hyphens, and underscores
                          if (!/^[a-zA-Z0-9_-]+$/.test(trimmedValue)) {
                            return Promise.reject(
                              new Error(
                                "Only alphabets, digits, hyphens (-), and underscores (_) are allowed."
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Vendor ID"
                      allowClear
                    />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please enter email",
                      },
                      {
                        validator: async (_: any, value: string) => {
                          if (!value) {
                            return Promise.resolve();
                          }

                          // Validates:
                          // - Standard email structure
                          // - No consecutive dots (..), dashes (--), or dot-dash/dash-dot (.-, -.)
                          const emailRegex =
                            /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
                          const consecutiveInvalidsRegex =
                            /(\.\.|--|-\.)|(\.-)/;

                          if (
                            !emailRegex.test(value) ||
                            consecutiveInvalidsRegex.test(value)
                          ) {
                            return Promise.reject(
                              new Error(
                                "Please enter a valid email (no repeated or mixed special characters)"
                              )
                            );
                          }

                          return new Promise<void>((resolve, reject) => {
                            checkEmailExist(value, (result: string) => {
                              if (result) {
                                reject(new Error(result));
                              } else {
                                resolve();
                              }
                            });
                          });
                        },
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Enter email" allowClear />
                  </Form.Item>

                  {/* <Form.Item
                  name="nid"
                  label="NID"
                  rules={[
                    {
                      required: true,
                      message: "Please enter NID",
                    },
                    {
                      validator: async (_: any, value: string) => {
                        if (!value) {
                          return Promise.resolve();
                        }

                        if (!/^\d+$/.test(value)) {
                          return Promise.reject(
                            new Error("NID must be number")
                          );
                        }

                        if (value.length < 10) {
                          return Promise.reject(
                            new Error("NID should be minimum 10 digits")
                          );
                        }

                        if (value.length > 20) {
                          return Promise.reject(
                            new Error("NID should not exceed 20 digits")
                          );
                        }

                        return new Promise<void>((resolve, reject) => {
                          checkNIDExist(value, (result: string) => {
                            if (result) {
                              reject(new Error(result));
                            } else {
                              resolve();
                            }
                          });
                        });
                      },
                    },
                  ]}
                >
                  <Input
                    className="w-full"
                    size="large"
                    placeholder="Enter NID"
                    allowClear
                  />
                </Form.Item> */}

                  <Form.Item
                    name="region"
                    label="Select Cluster"
                    rules={[
                      {
                        required: true,
                        message: "Please select cluster",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select cluster"
                      size="large"
                      allowClear
                      showSearch
                      filterOption={selectSearchOption}
                      options={ArrayOption(
                        [...regions].sort((a, b) =>
                          a.regionName.localeCompare(b.regionName)
                        ),
                        "regionName",
                        "_id",
                        true
                      )}
                      onChange={(val) => {
                        setSelectRegion(val);
                        setSelectArea("");
                        form.setFieldValue("area", undefined);
                        form.setFieldValue("teritory", undefined);
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="area"
                    label="Select Zonal"
                    rules={[
                      {
                        required: true,
                        message: "Please select zonal",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select zonal"
                      size="large"
                      allowClear
                      showSearch
                      filterOption={selectSearchOption}
                      options={ArrayOption(
                        [...areas].sort((a, b) =>
                          a.areaName.localeCompare(b.areaName)
                        ),
                        "areaName",
                        "_id",
                        true
                      )}
                      onChange={(val) => {
                        setSelectArea(val);
                        form.setFieldValue("teritory", undefined);
                      }}
                      disabled={!selectRegion}
                    />
                  </Form.Item>
                  <Form.Item
                    name="territory"
                    label="Select Territory"
                    rules={[
                      {
                        required: true,
                        message: "Please select territory",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select territory"
                      size="large"
                      allowClear
                      showSearch
                      filterOption={selectSearchOption}
                      options={ArrayOption(
                        [...territorys].sort((a, b) =>
                          a.teritoryName.localeCompare(b.teritoryName)
                        ),
                        "teritoryName",
                        "_id",
                        true
                      )}
                      disabled={!selectArea}
                    />
                  </Form.Item>

                  <Form.List initialValue={[undefined]} name="contactNumber">
                    {(fields, { add, remove }) => {
                      return (
                        <div>
                          {fields?.map((field, index) => (
                            <div
                              className="grid grid-cols-7 items-center"
                              key={field.key}
                            >
                              <Form.Item
                                name={[index]}
                                label="Contact Number"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter phone number",
                                  },
                                  {
                                    pattern: /^(\+88)?(01[3-9])[0-9]{8}$/,
                                    message:
                                      "Please enter a valid Bangladeshi phone number",
                                  },
                                ]}
                                className="col-span-6"
                              >
                                <Input
                                  size="large"
                                  prefix={"BD "}
                                  placeholder="Mobile No:"
                                />
                              </Form.Item>

                              {fields.length > 1 ? (
                                <div className="flex justify-end mt-1">
                                  <button
                                    className="w-8 h-8 rounded-full bg-[#FFDCDA] border-none cursor-pointer"
                                    onClick={() => remove(field.name)}
                                  >
                                    <DeleteIcon />
                                  </button>
                                </div>
                              ) : null}
                            </div>
                          ))}
                          <div className="flex justify-end">
                            <Button type="primary" onClick={() => add()}>
                              <PlusOutlined /> Add Contact
                            </Button>
                          </div>
                        </div>
                      );
                    }}
                  </Form.List>

                  {/* <Form.Item
                  name="suppler"
                  label="Select Supplier"
                  rules={[
                    {
                      required: true,
                      message: "Please select supplier",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select supplier"
                    size="large"
                    allowClear
                    showSearch
                    filterOption={selectSearchOption}
                    options={ArrayOption(
                      [...allSupplier].sort((a, b) =>
                        a.supplierName.localeCompare(b.supplierName)
                      ),
                      "supplierName",
                      "_id"
                    )}
                    disabled={
                      path === "vendor" &&
                      allSupplier?.find((el) => el?._id === login?.suppler)
                        ? true
                        : false
                    }
                  />
                </Form.Item> */}

                  {/* <Form.Item
          name="role"
          label="Select Role"
          rules={[
            {
              required: true,
              message: "Please select role",
            },
          ]}
          initialValue={"pg"}
        >
          <Select
            placeholder="Select role"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={ArrayOption(roleData, "name", "value")}
          />
        </Form.Item> */}

                  {/* <Form.Item
          name="lattitude"
          label="Latitude"
          rules={[
            {
              required: true,
              message: "Please enter latitude",
            },
            {
              type: "number",
              min: 0,
              message: "Latitude can't be negative",
            },
          ]}
        >
          <InputNumber
            className="w-full"
            size="large"
            placeholder="Enter latitude"
          />
        </Form.Item>

        <Form.Item
          name="longitude"
          label="Longitude"
          rules={[
            {
              required: true,
              message: "Please enter longitude",
            },
            {
              type: "number",
              min: 0,
              message: "Longitude can't be negative",
            },
          ]}
        >
          <InputNumber
            className="w-full"
            size="large"
            placeholder="Enter longitude"
          />
        </Form.Item> */}

                  {/* <Form.Item
                  name="pass"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter password",
                    },
                    {
                      min: 8,
                      message: "Password must be minimum 8 characters.",
                    },
                  ]}
                >
                  <Input.Password
                    // prefix={<PassKeyIcon />}
                    size="large"
                    placeholder="Password"
                  />
                </Form.Item>
                <Form.Item
                  name="confirmPass"
                  label="Confirm Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter confirm password",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("pass") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "Password and Confirm password do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password size="large" placeholder="Confirm Password" />
                </Form.Item> */}
                </div>

                <div className="flex items-center gap-4 mb-5">
                  <div className="text-slate-600 text-lg font-semibold">
                    Bank Payment Information
                  </div>
                  <div className="flex-1 h-px bg-zinc-200"></div>
                </div>

                <div className="grid grid-cols-2 items-center gap-x-6 gap-y-0">
                  <Form.Item
                    name="bankName"
                    label="Bank Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter bank name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter bank name"
                      allowClear
                    />
                  </Form.Item>
                  <Form.Item
                    name="accountNumber"
                    label="Account Number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter account number",
                      },
                      {
                        validator: (_, value) => {
                          if (value && value.includes(".")) {
                            return Promise.reject(
                              "Account Number can not be decimal"
                            );
                          }
                          if (value && Number(value) < 0) {
                            return Promise.reject(
                              "Account Number can not be negative"
                            );
                          }
                          if (value && !/^[0-9]+$/.test(value)) {
                            return Promise.reject(
                              "Account Number can not be letters or Character or Special Character"
                            );
                          }

                          if (value && value.length < 10) {
                            return Promise.reject(
                              "Account Number must be at least 10 digits"
                            );
                          }
                          if (value && value.length > 13) {
                            return Promise.reject(
                              "Account Number cannot exceed 13 digits"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter account number"
                      allowClear
                      type="text"
                    />
                  </Form.Item>

                  <Form.Item
                    name="accountName"
                    label="Account Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter account name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter account name"
                      allowClear
                    />
                  </Form.Item>

                  <Form.Item
                    name="routingNumber"
                    label="Routing Number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter routing number",
                      },
                      {
                        validator: (_, value) => {
                          if (value && value.includes(".")) {
                            return Promise.reject(
                              "Routing Number can not be decimal"
                            );
                          }
                          if (value && Number(value) < 0) {
                            return Promise.reject(
                              "Routing Number can not be negative"
                            );
                          }
                          if (value && !/^[0-9]+$/.test(value)) {
                            return Promise.reject(
                              "Routing number can not be letters or Character or Special Character"
                            );
                          }

                          if (value && value.length < 9) {
                            return Promise.reject(
                              "Routing Number must be exactly 9 digits"
                            );
                          }
                          if (value && value.length > 9) {
                            return Promise.reject(
                              "Routing Number must be exactly 9 digits"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input size="large" placeholder="0" allowClear />
                  </Form.Item>

                  <Form.Item
                    name="branch"
                    label="Branch"
                    rules={[
                      {
                        required: true,
                        message: "Please enter branch",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter branch name"
                      allowClear
                    />
                  </Form.Item>

                  <Form.Item
                    name="walletNumber"
                    label="sPay Wallet Number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter sPay wallet number",
                      },
                      {
                        validator: (_, value) => {
                          if (value && value.includes(".")) {
                            return Promise.reject(
                              "Wallet Number can not be decimal"
                            );
                          }
                          if (value && Number(value) < 0) {
                            return Promise.reject(
                              "Wallet Number can not be negative"
                            );
                          }
                          if (value && !/^[0-9]+$/.test(value)) {
                            return Promise.reject(
                              "Wallet Number can not be letters or Character or Special Character"
                            );
                          }

                          if (value && value.length < 11) {
                            return Promise.reject(
                              "Please enter a valid Bangladeshi sPay wallet number"
                            );
                          }
                          if (value && value.length > 11) {
                            return Promise.reject(
                              "Please enter a valid Bangladeshi sPay wallet number"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input size="large" placeholder="#" allowClear />
                  </Form.Item>
                </div>

                <div className="max-w-xl mx-auto pt-1 grid grid-cols-2 items-center gap-x-6 gap-y-0">
                  <Link className="block w-full cancel_btn" to="/np/vendor">
                    <Button block size="large">
                      Cancel
                    </Button>
                  </Link>
                  <Button
                    type="primary"
                    // disabled={disabledSubmit || disabled}
                    size="large"
                    htmlType="submit"
                    block
                    loading={postLoading || updateLoading}
                  >
                    {id ? "Update" : "Submit"}
                  </Button>
                </div>
              </Form>
            </div>
          </section>
        )}
      </AdminLayout>
    </>
  );
}
